define('app/visualizations/ValidationView',['require','glu/itemView','hbs!./ValidationView.hbs'],function(require) {
	'use strict';

	var ItemView = require('glu/itemView');

	return ItemView.extend({
		template: require('hbs!./ValidationView.hbs'),

		initialize: function() {
			this.generateRequirements();
		},

		onRender: function() {
			this.$el.find('.validation-view').fadeIn();
		},

		getChartType: function() {
			return this.model.getVisualization();
		},

		getChartTypeEnglish: function() {
			switch (this.model.getVisualization()) {
				case 'table':
					return;
				case 'donut-chart':
					return 'donut chart';
				case 'line-chart':
					return 'line chart';
				case 'bar-chart':
					return 'bar chart';
				case 'pie-chart':
					return 'pie chart';
				case 'stacked-bar-chart':
					return 'stacked bar chart';
				case 'scatter-plot':
					return 'scatter plot';
				case 'pivot-table':
					return 'pivot table';
				default:
					return 'unknown visualization type';
			}
		},

		generateRequirements: function() {
			this.visualizationRequirements = [];

			switch (this.model.getVisualization()) {
				case 'table':
					return;
				case 'donut-chart':
					this.visualizationRequirements.push({
						requirement: 'At least one aggregated column'
					});
					this.visualizationRequirements.push({
						requirement: 'A valid selected cell from an aggregated column'
					});
					break;
				case 'line-chart':
				case 'bar-chart':
				case 'pie-chart':
					this.visualizationRequirements.push({
						requirement: 'At least one grouped column'
					});
					this.visualizationRequirements.push({
						requirement: 'At least one aggregated column'
					});
					this.visualizationRequirements.push({
						requirement: 'Fewer than ' + this.model.getMaxRecordCount() + ' rows'
					});
					break;
				case 'stacked-bar-chart':
					this.visualizationRequirements.push({
						requirement: 'One grouped column'
					});
					this.visualizationRequirements.push({
						requirement: 'One aggregated column'
					});
					this.visualizationRequirements.push({
						requirement: 'Fewer than ' + this.model.getMaxRecordCount() + ' rows'
					});
					break;
				case 'scatter-plot':
					this.visualizationRequirements.push({
						requirement: 'One grouped column'
					});
					this.visualizationRequirements.push({
						requirement: 'Two or three aggregated columns'
					});
					this.visualizationRequirements.push({
						requirement: 'Fewer than ' + this.model.getMaxRecordCount() + ' rows'
					});
					break;
				case 'pivot-table':
					this.visualizationRequirements.push({
						requirement: 'Two grouped columns'
					});
					this.visualizationRequirements.push({
						requirement: 'One aggregated column'
					});
					this.visualizationRequirements.push({
						requirement: 'Fewer than ' + this.model.getMaxRecordCount() + ' rows'
					});
					break;
			}
		},

		getValidationMessage: function() {
			var self = this;

			// General validation failures
			if (this.model.hasNoColumns()) {
				return 'You must have at least one column.';
			}

			if (!this.model.countAggregateColumns() || this.model.countAggregateColumns() === 0) {
				return 'You must have at least one aggregated column';
			}

			// Widgets don't have consumableResults, so we need to make sure it exists
			if (this.model.consumableResults()) {
				if (!this.model.getMaxRecordCount() || this.model.consumableResults().recordCount() > this.model.getMaxRecordCount()) {
					return 'You must less than ' + this.model.getMaxRecordCount() + ' total rows, and you currently have ' + this.model.consumableResults().recordCount();
				}
			}

			// Type specific validation
			switch (this.model.getVisualization()) {
				case 'table':
					return;
				case 'donut-chart':
					if (!this.model.get('selectedName')) {
						return 'You must select a valid cell from an aggregated column';
					}
					break;
				case 'line-chart':
					if (!self.model.countGroupColumns() || self.model.countGroupColumns() === 0) {
						return 'You must have at least one grouped column';
					}
					break;
				case 'bar-chart':
					if (!self.model.countGroupColumns() || self.model.countGroupColumns() === 0) {
						return 'You must have at least one grouped column';
					}
					break;
				case 'pie-chart':
					if (!self.model.countGroupColumns() || self.model.countGroupColumns() === 0) {
						return 'You must have at least one grouped column';
					}
					break;
				case 'stacked-bar-chart':
					if (!self.model.countGroupColumns() || self.model.countGroupColumns() === 0) {
						return 'You must have at least one grouped column';
					}
					break;
				case 'scatter-plot':
					if (!self.model.countGroupColumns() || self.model.countGroupColumns() === 0) {
						return 'You must have at least one grouped column';
					}
					if (!this.model.countAggregateColumns() || this.model.countAggregateColumns() < 2 || this.model.countAggregateColumns() > 3) {
						return 'You must have two or three aggregated columns';
					}
					break;
				case 'pivot-table':
					if (!self.model.countGroupColumns() || self.model.countGroupColumns() === 0) {
						return 'You must have at least one grouped column';
					}
					if (!this.model.countGroupColumns() || this.model.countGroupColumns() !== 2) {
						return 'You must have two grouped columns';
					}
					break;
			}
		},

		getMaxRecordCount: function() {
			return this.model.getMaxRecordCount();
		},

		getGroupsString: function() {
			switch (this.model.getVisualization()) {
				case 'table':
					return;
				case 'donut-chart':
					return '0<small>+</small>';
				case 'line-chart':
				case 'bar-chart':
				case 'pie-chart':
					return '1<small>+</small>';
				case 'stacked-bar-chart':
					return '1';
				case 'scatter-plot':
					return '1';
				case 'pivot-table':
					return '2';
				default:
					throw new Error('Unknown visualization="' + this.model.getVisualization() + '"');
			}
		},

		getAggregationsString: function() {
			switch (this.model.getVisualization()) {
				case 'table':
					return;
				case 'donut-chart':
					return '1<small>+</small>';
				case 'line-chart':
					return '1<small>+</small>';
				case 'bar-chart':
					return '1<small>+</small>';
				case 'pie-chart':
					return '1<small>+</small>';
				case 'stacked-bar-chart':
					return '1';
				case 'scatter-plot':
					return '2 <small>or</small> 3';
				case 'pivot-table':
					return '1';
				default:
					throw new Error('Unknown visualization="' + this.model.getVisualization() + '"');
			}
		},

		serializeData: function() {
			return this;
		},

		isDonutChart: function() {
			return this.model.getVisualization() === 'donut-chart';
		}
	});
});

